var e={lightTheme:{MuiTab:{styleOverrides:{root:{textTransform:"none"}}}}};export{e as default};